import { Card } from 'components/atoms';
import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { IAdvance } from 'services/advance/types';

const AdvanceContracts = () => {
  const { t } = useTranslation();

  const { values, setFieldValue, status } = useFormikContext<IAdvance>();

  return (
    <>
      <ListWrapper
        style={{ paddingBottom: 100 }}
        items={values.contracts}
        isLoading={status.isLoading}
        item={contract => <Card key={contract.id} header={contract.title} />}
      />
      {/* {!values.repaymentsFromAllContracts && (
        <Table
          id={"AdvanceContracts"}
          size="compact"
          data={{
            nodes: values.contracts
              ? values.contracts?.map((contract, idx) => ({
                  index: idx,
                  title: contract.title,
                  id: contract.id,
                }))
              : [],
          }}
          columns={[
            {
              label: t("label.table.contracts"),
              renderCell: ({ index, id, title }) => (
                <div className="flex justify-between">
                  <FormInput.Select
                    options={contractOptions}
                    name={`contracts[${index}].id`}
                    value={{
                      label: title,
                      value: id,
                    }}
                    onChange={(newValue) => {
                      setFieldValue(
                        `contracts[${index}].title`,
                        newValue.label
                      );
                    }}
                  />
                  {!status?.displayMode && (
                    <Button
                      variant={BUTTON_VARIANT.remove}
                      isClear
                      onlyIcon
                      onClick={() => {
                        setFieldValue(
                          "contracts",
                          values.contracts.filter(
                            (contract) => contract.id !== id
                          )
                        );
                      }}
                    >
                      <Button.Icon icon={<PiTrash />} />
                    </Button>
                  )}
                </div>
              ),
              resize: true,
            },
          ]}
          tableOptions={
            status?.displayMode
              ? undefined
              : {
                  renderAfterTable: () => (
                    <tfoot className="full-width-footer">
                      <TableMessage
                        className="cursor-pointer"
                        onClick={() => {
                          setFieldValue(
                            `contracts[${values.contracts.length}]`,
                            {
                              id: "",
                              title: "",
                            }
                          );
                        }}
                      >
                        <TableItem.Text text={t("button.add")} />
                        <PiPlus />
                      </TableMessage>
                    </tfoot>
                  ),
                }
          }
        />
      )} */}
    </>
  );
};

export default AdvanceContracts;
